import { apiGet, apiPost } from '@/utils/api';
import getPath from '@/utils/getPath';
import { handleApiError } from '@/utils/errorHandler';

export const denialsStatsApi = {
  /**
   * @apiRoute GET '/stats/denials/insights/last-updated'
   */
  async getLastUpdated() {
    try {
      return await apiGet(getPath('stats/denials/insights/last-updated'));
    } catch (err) {
      await handleApiError(
        err,
        'getLastUpdated',
        true,
        'Error fetching last updated'
      );
    }
  },

  /**
   * @apiRoute POST '/stats/denials/details'
   */
  async getDetails(payload) {
    try {
      return await apiPost(getPath('stats/denials/details'), payload);
    } catch (err) {
      await handleApiError(err, 'getDetails', true, 'Error fetching details');
    }
  },

  /**
   * @apiRoute POST '/stats/denials/insights/<type>'
   */
  async getAverageTotalInsights(payload) {
    try {
      return await apiPost(
        getPath('stats/denials/insights/average-total'),
        payload
      );
    } catch (err) {
      await handleApiError(
        err,
        'getAverageTotalInsights',
        true,
        'Error fetching insights'
      );
    }
  },

  /**
   * @apiRoute POST '/stats/denials/insights/<type>'
   */
  async getFinancialClassInsights(payload) {
    try {
      return await apiPost(
        getPath('stats/denials/insights/financial-class'),
        payload
      );
    } catch (err) {
      await handleApiError(
        err,
        'getFinancialClassInsights',
        true,
        'Error fetching insights'
      );
    }
  },

  /**
   * @apiRoute POST '/stats/denials/insights/<type>'
   */
  async getCategoryInsights(payload) {
    try {
      return await apiPost(getPath('stats/denials/insights/category'), payload);
    } catch (err) {
      await handleApiError(
        err,
        'getCategoryInsights',
        true,
        'Error fetching insights'
      );
    }
  },

  /**
   * @apiRoute POST '/stats/denials/breakout/<type>'
   */
  async getBreakoutChart(payload) {
    try {
      return await apiPost(getPath('stats/denials/breakout/chart'), payload);
    } catch (err) {
      await handleApiError(
        err,
        'getBreakoutChart',
        true,
        'Error fetching breakout chart'
      );
    }
  },

  /**
   * @apiRoute POST '/stats/denials/breakout/<type>'
   */
  async getBreakoutTable(payload) {
    try {
      return await apiPost(getPath('stats/denials/breakout/table'), payload);
    } catch (err) {
      await handleApiError(
        err,
        'getBreakoutTable',
        true,
        'Error fetching breakout table'
      );
    }
  },
};
